import { type ConfirmationModalProps, ConfirmationModal, Text } from '@shared/components';

type QuestionReviewFinishTaskConfirmationModalProps = Pick<
  ConfirmationModalProps,
  'loading' | 'onClose' | 'open' | 'onAccept'
>;

export default function QuestionReviewFinishTaskConfirmationModal(
  props: Readonly<QuestionReviewFinishTaskConfirmationModalProps>,
) {
  const { loading: isLoading, open: isOpen, onClose, onAccept } = props;

  return (
    <ConfirmationModal
      title='Finish Task?'
      open={isOpen}
      loading={isLoading}
      acceptText='Finish'
      content={
        <Text>
          คุณแน่ใจหรือไม่ว่าต้องการจบ Task นี้?
          <br />
          หลังจากส่งงานแล้ว จะไม่สามารถแก้ไขได้อีก
        </Text>
      }
      onDiscard={onClose}
      onClose={onClose}
      onAccept={onAccept}
    />
  );
}
